/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState, useEffect } from "react";
import "./styles.css";
import { Button, Form, Row, Col } from "react-bootstrap";
import { Validator, ValidatorConfig } from "json-data-validator";
import { RuleFactory } from "json-data-validator/build/src/rules/RuleFactory";
import { GenericValidator } from "json-data-validator/build/src/rules/GenericValidator";
import { RuleConfig } from "json-data-validator/build/src/config/RuleConfig";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import {
    TextInput,
    ITextInputProps,
    EmailInput,
    IEmailInputProps,
    TextAreaInput,
    ITextAreaInputProps,
    PasswordInput,
    IPasswordInputProps,
    ChoosePhoto,
    IChoosePhotoProps,
    ImageDropZone,
    IImageDropZoneProps,
    FileDropZone,
    IFileDropZoneProps,
    DatePicker,
    IDatePickerProps,
    DateTimePicker,
    IDateTimePickerProps,
    IRadioButtonProps,
    RadioButton,
    BooleanButton,
    IBooleanButtonProps,
    INumberInputProps,
    NumberInput,
    HtmlEditor,
    IHtmlEditorProps,
    DynamicFields,
    IDynamicFieldsProps,
    ColorPicker,
    IColorPickerProps,
    SelectInput,
    ISelectInputProps,
    CountrySelectInput,
    ICountrySelectInputProps,
    PhoneNumberInput,
    IPhoneNumberInputProps,
    OTPInputComp,
    IOTPInputCompProps,
    SectionTitle,
    ISectionTitleProps,
    CheckBox,
    ICheckBoxProps,
    ICreatableSelectInputProps,
    CreatableSelectInput,
    Coupon,
} from "./components";

const SwalWithBootstrapButtons = withReactContent(
    Swal.mixin({
        customClass: {
            confirmButton: "btn btn-primary me-3",
            cancelButton: "btn btn-gray",
        },
        buttonsStyling: false,
    })
);

RuleFactory.register("MINLENGTH", (config: RuleConfig) => {
    return new GenericValidator(
        config,
        (value: string) => !value || value.length >= config.minlength!,
        `'%s' must have a length of minimum ${config.minlength}`
    );
});
export interface ITweetyWidgetCompProps {
    type:
    | "text"
    | "number"
    | "email"
    | "textarea"
    | "password"
    | "choosePhoto"
    | "imageDropZone"
    | "fileDropZone"
    | "datepicker"
    | "dateTimePicker"
    | "radio"
    | "bool"
    | "htmlEditor"
    | "dynamicFields"
    | "colorPicker"
    | "select"
    | "countrySelect"
    | "phoneNumber"
    | "otp"
    | "sectionTitle"
    | "createSelect"
    | "checkBox";
    compProps:
    | ITextInputProps
    | INumberInputProps
    | IEmailInputProps
    | ITextAreaInputProps
    | IPasswordInputProps
    | IChoosePhotoProps
    | IImageDropZoneProps
    | IFileDropZoneProps
    | IDatePickerProps
    | IDateTimePickerProps
    | IRadioButtonProps
    | IBooleanButtonProps
    | IHtmlEditorProps
    | IDynamicFieldsProps
    | IColorPickerProps
    | ISelectInputProps
    | ICountrySelectInputProps
    | IPhoneNumberInputProps
    | IOTPInputCompProps
    | ISectionTitleProps
    | ICreatableSelectInputProps
    | ICheckBoxProps;
}

export interface ITweetyWidgetProps {
    fields: ITweetyWidgetCompProps[];
    initialData?: any;
    submitButtonLabel?: string;
    validatorConfig?: ValidatorConfig;
    labelColor?: string;
    layout?: any[];
    dynamicLayout?: any[];
    onFormSubmit?(payload: any): void;
    renderSubmitButton?(): any;
    onSelectChange?(id: string, payload: any): void;
    textInnputValue?: string;
    submitButtonContainerStyle?: any;
}

const checkLayout = (id: string, obj: any[]) => {
    for (const str of obj) {
        const splitter = str?.split(":");
        if (splitter && splitter[0]) {
            if (splitter[0] === id) {
                return true;
            }
        }
    }
    return false;
};

export const TweetyWidget = ({
    fields,
    initialData,
    submitButtonLabel,
    onFormSubmit,
    renderSubmitButton,
    onSelectChange,
    labelColor,
    layout,
    validatorConfig,
    dynamicLayout,
    textInputValue,
    submitButtonContainerStyle,
}: ITweetyWidgetProps) => {
    console.log("fields", fields);

    const [formData, updateFormData] = useState<any>(initialData ?? {});
    const [fieldLayout, updateFieldLayout] = useState<any>(layout ?? []);
    const [validated, setValidated] = useState(false);
    const [errors, setErrors] = useState<any>({});
    const [errorMsg, setErrorMsg] = useState<any>({});
    const [lookupFields, updateLookupFields] = useState<any>({});
    useEffect(() => {
        if (initialData) {
            updateFormData((prevFormData) => ({
                ...prevFormData,
                ...initialData,
            }));
        }
    }, [initialData]);

    const handleSubmit = (e?: any) => {
        const form = e.currentTarget;
        const isValid = form.checkValidity();
        e.preventDefault();
        e.stopPropagation();
        let hasError = false;
        const errorsObj: any = {};
        const errorMsgObj: any = {};
        let _fields = [];
        if (fieldLayout && fieldLayout?.length) {
            for (const row of fieldLayout) {
                for (const col of row) {
                    const found = fields.find(
                        (obj) =>
                            obj?.compProps?.id === col ||
                            obj?.compProps?.id === col?.split(":")[0]
                    );
                    if (found) {
                        _fields.push(found);
                    }
                }
            }
        } else {
            _fields = fields;
        }
        for (const [index, field] of _fields?.entries()) {
            if (validatorConfig) {
                const data = {
                    [field?.compProps?.id]: formData[field?.compProps?.id],
                };
                const config =
                    validatorConfig?.ruleSets[0]?.fields[field?.compProps?.id];

                const _validatorConfig = {
                    ruleSets: [
                        {
                            fields: {},
                        },
                    ],
                };
                if (config) {
                    _validatorConfig.ruleSets[0].fields[field?.compProps?.id] =
                        config;
                }
                const validator = new Validator(_validatorConfig);
                const res = validator.validate(data);
                if (res?.valid === false) {
                    errorsObj[field.compProps.id] = true;
                    hasError = true;
                    errorMsgObj[field.compProps.id] = res?.message;
                } else if (
                    field?.compProps?.required &&
                    !formData[field?.compProps?.id]
                ) {
                    errorsObj[field.compProps.id] = true;
                    hasError = true;
                    errorMsgObj[field.compProps.id] =
                        field?.compProps?.errorText ??
                        `${field.compProps.label} is required`;
                }
            } else if (
                field?.compProps?.required &&
                !formData[field?.compProps?.id]
            ) {
                errorsObj[field.compProps.id] = true;
                hasError = true;
                errorMsgObj[field.compProps.id] =
                    field?.compProps?.errorText ??
                    `${field.compProps.label} is required`;
            }
        }
        // setValidated(true);
        console.log(formData, hasError);
        if (!hasError) {
            setErrors({});
            onFormSubmit && onFormSubmit(formData);
        } else {
            window?.scrollTo(0, 0);
            setErrors(errorsObj);
            setErrorMsg(errorMsgObj);
        }
    };
    const handleCompChange = (id: string, payload: any) => {
        if (id && payload && errors[id]) {
            delete errors[id];
        }
        onSelectChange && onSelectChange(id, payload);
        updateFormData({
            ...formData,
            [id]: payload,
        });
        console.log({
            ...formData,
            [id]: payload,
        });
        if (payload && dynamicLayout) {
            if (dynamicLayout[id]) {
                let found = false;
                let _layout: any;
                let _payload: string;
                if (
                    typeof payload === "string" &&
                    dynamicLayout[id][payload?.trim()?.toLowerCase()] !==
                    undefined
                ) {
                    found = true;
                    _layout = dynamicLayout[id][payload?.trim()?.toLowerCase()];
                    _payload = payload?.trim()?.toLowerCase();
                    updateLookupFields({
                        ...lookupFields,
                        [id]: _layout,
                    });
                } else if (Array.isArray(payload)) {
                    for (const pld of payload) {
                        if (typeof pld === "string") {
                            if (
                                dynamicLayout[id][
                                pld?.trim()?.toLowerCase()
                                ] !== undefined
                            ) {
                                found = true;
                                _layout =
                                    dynamicLayout[id][
                                    pld?.trim()?.toLowerCase()
                                    ];
                                _payload = pld?.trim()?.toLowerCase();
                                updateLookupFields({
                                    ...lookupFields,
                                    [id]: _layout,
                                });
                            }
                        }
                    }
                }
                if (found) {
                    const index = fieldLayout?.findIndex(
                        checkLayout.bind(null, id)
                    );
                    let checkIfExistingIndex = -1;
                    for (const lo of fieldLayout) {
                        for (const obj of lo) {
                            const splitter = obj.split(":");
                            if (splitter && splitter[0]) {
                                if (splitter[0] === _payload) {
                                    checkIfExistingIndex = 1;
                                    break;
                                }
                            }
                        }
                    }
                    if (
                        index !== -1 &&
                        checkIfExistingIndex === -1 &&
                        _layout
                    ) {
                        const originalLayout = [...fieldLayout];
                        originalLayout.splice(index + 1, 0, ..._layout);
                        updateFieldLayout(originalLayout);
                    }
                } else {
                    if (lookupFields[id] !== undefined) {
                        const originalLayout = [...fieldLayout];
                        const updatedLayout = originalLayout?.filter(
                            (lo: any) => {
                                let matched = false;
                                for (const dlo of lookupFields[id]) {
                                    if (dlo === lo) {
                                        matched = false;
                                        break;
                                    } else {
                                        matched = true;
                                    }
                                }
                                return matched;
                            }
                        );
                        updateFieldLayout(updatedLayout);
                        const _formData = { ...formData, [id]: payload };
                        for (const dlo of lookupFields[id]) {
                            for (const _str of dlo) {
                                const splitter = _str.split(":");
                                if (splitter && splitter[0]) {
                                    if (_formData[splitter[0]] !== undefined) {
                                        delete _formData[splitter[0]];
                                    }
                                }
                            }
                        }
                        console.log(_formData);
                        updateFormData({
                            ...(_formData || {}),
                        });
                    }
                }
            }
        }
    };
    const _renderFormGroup = (fldz: ITweetyWidgetCompProps[]) => {
        let _comp: any = [];
        for (const [index, field] of fldz.entries()) {
            if (field?.compProps) {
                field.compProps = {
                    ...field.compProps,
                    labelColor: labelColor,
                };
            } else {
                field.compProps = { labelColor: labelColor };
            }

            switch (field?.type) {
                case "text":
                    console.log(initialData, initialData[field?.compProps?.id], field?.compProps?.id)
                    _comp.push(
                        <TextInput
                            key={`tweety-text-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            value={initialData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case "number":
                    console.log(initialData, initialData[field?.compProps?.id], field?.compProps?.id)
                    _comp.push(
                        <NumberInput
                            key={`tweety-number-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            value={initialData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                            textBelow={textInputValue}
                        />
                    );
                    break;
                case "coupon":
                    _comp.push(
                        <Coupon
                            key={`tweety-coupon-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            value={initialData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                            textBelow={textInputValue}
                        />
                    );
                    break;
                case "email":
                    _comp.push(
                        <EmailInput
                            key={`tweety-email-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            value={initialData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case "textarea":
                    _comp.push(
                        <TextAreaInput
                            key={`tweety-textarea-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            value={initialData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case "password":
                    _comp.push(
                        <PasswordInput
                            key={`tweety-password-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            value={initialData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case "choosePhoto":
                    _comp.push(
                        <ChoosePhoto
                            key={`tweety-choose-photo-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            value={initialData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case "imageDropZone":
                    _comp.push(
                        <ImageDropZone
                            key={`tweety-image-drop-zone-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            value={initialData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case "fileDropZone":
                    _comp.push(
                        <FileDropZone
                            key={`tweety-file-drop-zone-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            value={initialData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case "datepicker":
                    _comp.push(
                        <DatePicker
                            key={`tweety-datepicker-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            value={initialData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case "dateTimePicker":
                    _comp.push(
                        <DateTimePicker
                            key={`tweety-date-time-picker-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            value={initialData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case "radio":
                    _comp.push(
                        <RadioButton
                            key={`tweety-date-radio-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            value={initialData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case "bool":
                    _comp.push(
                        <BooleanButton
                            key={`tweety-boolean-radio-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            value={initialData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case "htmlEditor":
                    _comp.push(
                        <HtmlEditor
                            key={`tweety-html-editor-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            value={initialData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case "dynamicFields":
                    _comp.push(
                        <DynamicFields
                            key={`tweety-dynamic-fields-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            value={initialData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case "colorPicker":
                    console.log(initialData[field?.compProps?.id]);
                    _comp.push(
                        <ColorPicker
                            key={`tweety-colorPicker-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            value={initialData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case "select":
                    console.log(initialData, initialData[field?.compProps?.id], field?.compProps?.id)
                    _comp.push(
                        <SelectInput
                            key={`tweety-select-input-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            value={initialData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case "createSelect":
                    console.log(
                        "field?.compProps?.value",
                        field?.compProps?.value,
                        field?.compProps?.value ??
                        initialData[field?.compProps?.id]
                    );
                    _comp.push(
                        <CreatableSelectInput
                            key={`tweety-createSelect-input-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            textVal={initialData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case "countrySelect":
                    _comp.push(
                        <CountrySelectInput
                            key={`tweety-country-select-input-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            value={initialData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case "phoneNumber":
                    _comp.push(
                        <PhoneNumberInput
                            key={`tweety-phone-number-input-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            value={initialData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case "otp":
                    _comp.push(
                        <OTPInputComp
                            key={`tweety-otp-input-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            value={initialData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                case "sectionTitle":
                    _comp.push(
                        <SectionTitle
                            key={`tweety-section-title-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                        />
                    );
                    break;
                case "checkBox":
                    _comp.push(
                        <CheckBox
                            key={`tweety-check-box-${field.compProps?.id}-${index}`}
                            {...(field?.compProps || {})}
                            onCompChange={handleCompChange}
                            value={initialData[field?.compProps?.id]}
                            hasError={!!errors[field?.compProps?.id]}
                            errorText={errorMsg[field?.compProps?.id]}
                        />
                    );
                    break;
                default:
                    console.log(`unsupported field type ${field?.type}`);
            }
        }
        return _comp;
    };

    const _renderSubmitButton = () => {
        if (renderSubmitButton) {
            return renderSubmitButton();
        }
        return (
            <div
                className="mt-3"
                style={submitButtonContainerStyle && submitButtonContainerStyle}
            >
                <Button
                    variant="secondary"
                    type="submit"
                    className="mt-2 animate-up-2"
                    style={{
                        width: "70%",
                        borderRadius: "0px",
                        height: "40px",
                        fontWeight: "bold",
                    }}
                >
                    {submitButtonLabel}
                </Button>
            </div>
        );
        // return (
        //   // <div className="d-grid">
        //     <Row>
        //       <Col sm={12}>
        //     <Button variant="secondary" type="submit" style={{}}>
        //       {submitButtonLabel}
        //     </Button>
        //         </Col>
        //       </Row>
        //   // </div>
        // );
    };

    const _renderFourColumns = (
        fieldz: ITweetyWidgetCompProps[],
        lo: string[]
    ) => {
        const _comp: any = [];
        const _sizer: any = {};
        for (const lay of lo) {
            const splitter = lay.split(":");
            if (splitter?.length === 2) {
                _sizer[splitter[0]] = Number(splitter[1]);
            }
        }
        for (const [index, field] of fieldz?.entries()) {
            _comp.push(
                <Col
                    key={`layout-4-columns-${index}`}
                    sm={
                        field.compProps.id in _sizer
                            ? _sizer[field.compProps.id]
                            : 3
                    }
                    className="mb-2"
                >
                    {_renderFormGroup([field])}
                </Col>
            );
        }
        return _comp;
    };

    const _renderThreeColumns = (
        fieldz: ITweetyWidgetCompProps[],
        lo: string[]
    ) => {
        const _comp: any = [];
        const _sizer: any = {};
        for (const lay of lo) {
            const splitter = lay.split(":");
            if (splitter?.length === 2) {
                _sizer[splitter[0]] = Number(splitter[1]);
            }
        }
        for (const [index, field] of fieldz?.entries()) {
            _comp.push(
                <Col
                    key={`layout-3-columns-${index}`}
                    sm={
                        field.compProps.id in _sizer
                            ? _sizer[field.compProps.id]
                            : 4
                    }
                    className="mb-2"
                >
                    {_renderFormGroup([field])}
                </Col>
            );
        }
        return _comp;
    };

    const _renderTwoColumns = (
        fieldz: ITweetyWidgetCompProps[],
        lo: string[]
    ) => {
        const _comp: any = [];
        const _sizer: any = {};
        for (const lay of lo) {
            const splitter = lay.split(":");
            if (splitter?.length === 2) {
                _sizer[splitter[0]] = Number(splitter[1]);
            }
        }
        for (const [index, field] of fieldz?.entries()) {
            _comp.push(
                <Col
                    key={`layout-2-columns-${index}`}
                    sm={
                        field.compProps.id in _sizer
                            ? _sizer[field.compProps.id]
                            : 6
                    }
                    className="mb-2"
                >
                    {_renderFormGroup([field])}
                </Col>
            );
        }
        return _comp;
    };

    const _renderOneColumn = (
        fieldz: ITweetyWidgetCompProps[],
        lo: string[] = []
    ) => {
        const _comp: any = [];
        const _sizer: any = {};
        for (const lay of lo) {
            const splitter = lay.split(":");
            if (splitter?.length === 2) {
                _sizer[splitter[0]] = Number(splitter[1]);
            }
        }
        for (const [index, field] of fieldz?.entries()) {
            _comp.push(
                <Col
                    key={`layout-1-columns-${index}`}
                    sm={
                        field.compProps.id in _sizer
                            ? _sizer[field.compProps.id]
                            : 12
                    }
                    className="mb-2"
                >
                    {_renderFormGroup([field])}
                </Col>
            );
        }
        return _comp;
    };

    const _renderLayout = () => {
        const _comp: any = [];
        if (fieldLayout && fieldLayout?.length > 0) {
            for (const [index, lo] of fieldLayout?.entries()) {
                if (lo.length === 4) {
                    const _lo = lo.map((obj) => obj.split(":")[0]);
                    const filtered = fields?.filter((field) =>
                        _lo.includes(field?.compProps?.id)
                    );
                    _comp.push(
                        <Row key={`layout-4-row-${index}`}>
                            {_renderFourColumns(filtered, lo)}
                        </Row>
                    );
                } else if (lo.length === 3) {
                    const _lo = lo.map((obj) => obj.split(":")[0]);
                    const filtered = fields?.filter((field) =>
                        _lo.includes(field?.compProps?.id)
                    );
                    _comp.push(
                        <Row key={`layout-3-row-${index}`}>
                            {_renderThreeColumns(filtered, lo)}
                        </Row>
                    );
                } else if (lo.length === 2) {
                    const _lo = lo.map((obj) => obj.split(":")[0]);
                    const filtered = fields?.filter((field) =>
                        _lo.includes(field?.compProps?.id)
                    );
                    _comp.push(
                        <Row key={`layout-2-row-${index}`}>
                            {_renderTwoColumns(filtered, lo)}
                        </Row>
                    );
                } else if (lo.length === 1) {
                    const _lo = lo.map((obj) => obj.split(":")[0]);
                    const filtered = fields?.filter((field) =>
                        _lo.includes(field?.compProps?.id)
                    );
                    _comp.push(
                        <Row key={`layout-1-row-${index}`}>
                            {_renderOneColumn(filtered, lo)}
                        </Row>
                    );
                } else {
                    console.log(`unsupported number of columns ${lo.length}`);
                }
            }
        } else {
            _comp.push(
                <Row key={`layout-1-row-default-layout`}>
                    {_renderOneColumn(fields)}
                </Row>
            );
        }
        return _comp;
    };

    return (
        <>
            <Form
                noValidate
                validated={validated}
                className="mt-4"
                autoComplete="off"
                onSubmit={handleSubmit}
            >
                {_renderLayout()}
                {/*{_renderFormGroup()}*/}
                {_renderSubmitButton()}
            </Form>
        </>
    );
};

TweetyWidget.defaultProps = {
    initialData: {},
    submitButtonLabel: "Submit",
    labelColor: "#000000",
};
